<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true" class="no-field-space change-catalog-title-dialog">
    <sc-dialog-title>
        {{ 'change Catalog title' | translate: ['erp.ui.edit-catalog.title', translationService.language]}}
    </sc-dialog-title>
    <sc-separator-line></sc-separator-line>
    <sc-padding>
        <div style="width: 450px;">
            <sc-dictionary-field class="name-input" [model]="name" [maxlength]="255" defaultLabel="Name"
                labelDictionaryKey="erp.entity.catalog.name" (dictionaryChanged)="onNameChanged($event)">
            </sc-dictionary-field>
        </div>
    </sc-padding>
    <sc-separator-line></sc-separator-line>
    <sc-actionbar>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button (click)="onClose()">
          {{ 'Abbrechen' | translate: ['erp.ui.edit-catalog.action.cancel', translationService.language]}}
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled()">
          {{ 'Übernehmen' | translate: ['erp.ui.add-catalog.action.confirm', translationService.language]}}
        </button>
    </sc-actionbar>
</sc-flex>
